import App from 'app/app.js';
import 'app/service/IdentityService.js';
import 'app/service/RouterService.js';
import { isElevationRequired, IDENTITY_TOKEN_HEADER } from '@app/interceptor/interceptor-logic';

function IdentityInterceptor($injector, $q) {
  return {
    request: function (config) {
      var IdentityService = $injector.get('IdentityService');
      if (!!IdentityService.getCurrentUser()) {
        return IdentityService.getJwt().then(
          function (jwt) {
            config.headers[IDENTITY_TOKEN_HEADER] = jwt;
            return config;
          },
          function () {
            return config;
          }
        );
      }
      return config;
    },
    responseError: function (response) {
      if (isElevationRequired(response.data)) {
        var IdentityService = $injector.get('IdentityService');
        IdentityService.goToElevation();
      }
      return $q.reject(response);
    }
  };
}

App.factory('IdentityInterceptor', ['$injector', '$q', IdentityInterceptor]);
App.config([
  '$httpProvider',
  function ($httpProvider) {
    $httpProvider.interceptors.push('IdentityInterceptor');
  }
]);
